import { render, staticRenderFns } from "./StarterModal.vue?vue&type=template&id=1c91a62e&"
import script from "./StarterModal.vue?vue&type=script&lang=js&"
export * from "./StarterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports